import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'filterToApp'
})

export class FilterSendToApp implements PipeTransform {
    transform(items: any[], toApp: number): any {
        if(!items || toApp == null){
            return items;
        }
        return items.filter(item => item.app_queue == 0)
    }
}


// WEBPACK FOOTER //
// ./src/app/pipes/filter-sendToApp.pipe.ts